import MonitoringReportResultsViewModel from "./MonitoringReportResultsViewModel";

export default class ExportMonitoringReportViewModel {
    addUserComments: boolean = false;
    displayDirectlyToScreen: boolean = true;
    fileName: string = '';
    userComments: string = '';
    siteReference: string = '';
    monitoringReportResults: MonitoringReportResultsViewModel[] = [];
    version: string = '1';
}
